import { ValidHeimspielScheduleProps } from './types'

const isValidHeimspielScheduleProps = (
  props: any
): props is ValidHeimspielScheduleProps => !!props?.matchId

export { isValidHeimspielScheduleProps }
